<template>
  <div>
    <app-navigation-toolbar v-if="!showAdminPanel" @changeToAdmin="adminPanel = true">
      <template slot="topDrawerMenu">
        <slot v-if="$slots.topDrawerMenu" name="topDrawerMenu"></slot>
      </template>
      <template slot="endDrawerMenu">
        <slot v-if="$slots.endDrawerMenu" name="endDrawerMenu"></slot>
      </template>
      <template slot="subSectionMenu">
        <slot v-if="$slots.subSectionMenu" name="subSectionMenu"></slot>
      </template>
    </app-navigation-toolbar>
    <app-admin-navigation-toolbar
      v-if="showAdminPanel"
      @changeToPublic="adminPanel = false"
    ></app-admin-navigation-toolbar>
    <template slot="topDrawerMenu">
      <slot v-if="$slots.topDrawerMenu" name="topDrawerMenu"></slot>
    </template>
    <template slot="endDrawerMenu">
      <slot v-if="$slots.endDrawerMenu" name="endDrawerMenu"></slot>
    </template>
    <v-content class="main-content">
      <slot></slot>
    </v-content>

    <app-footer />
  </div>
</template>

<script>
import AppNavigationToolbar from './sections/AppNavigationToolbar';
import AppAdminNavigationToolbar from './sections/AppAdminNavigationToolbar';

import AppFooter from './sections/AppFooter';

export default {
  components: {
    AppNavigationToolbar,
    AppAdminNavigationToolbar,
    AppFooter,
  },
  data: () => ({
    adminPanel: false,
  }),

  computed: {
    showAdminPanel() {
      let adminPanel = false;
      let segments = this.$router.currentRoute.fullPath.split('/');
      if (Array.isArray(segments) && segments[1] && segments[1] == 'admin') {
        adminPanel = true;
      }
      return this.$store.state.admin && adminPanel;
    },
  },
};
</script>

<style>
.main-content {
  min-height: 100vh;
}
</style>
